import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useWebSocket } from "WebSocketContext";
import { BUTTON_PRIMARY, PAGE_BACKGROUND, PANEL_CLASS } from "./uiConstants";

type WaitingScreenProps = {
  isHost: boolean;
  onStartGame: () => void;
};

const WaitingScreen: React.FC<WaitingScreenProps> = ({ isHost, onStartGame }) => {
  const navigate = useNavigate();
  const { isConnected } = useWebSocket();
  const wasConnectedRef = useRef(isConnected);
  const wasHostRef = useRef(isHost);

  useEffect(() => {
    if (isHost) {
      wasHostRef.current = true;
    }
  }, [isHost]);

  useEffect(() => {
    if (isConnected) {
      wasConnectedRef.current = true;
      return;
    }
    if (!wasConnectedRef.current) {
      return;
    }

    navigate(wasHostRef.current ? "/vow/host" : "/vow/join", { replace: true });
  }, [isConnected, navigate]);

  return (
    <div className={`flex min-h-screen items-center justify-center ${PAGE_BACKGROUND}`}>
      <div className={`${PANEL_CLASS} mx-4 max-w-md p-6 text-center`}>
        <h1 className="text-2xl font-semibold text-slate-900">VOW - Voices of Wetland</h1>
        <p className="mt-2 text-sm text-slate-700">Waiting for the host to start the session…</p>
        {isHost && (
          <div className="mt-4 flex flex-col items-center gap-3">
            <p className="text-xs text-slate-700">
              Start when all players have confirmed their roles.
            </p>
            <button type="button" onClick={onStartGame} className={BUTTON_PRIMARY}>
              Start Game
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default WaitingScreen;
